import React from 'react'
import get from 'lodash/get'

import CardFan from '@components/programmatic_blocks/card_fan'
import Markdown from '@components/markdown'
import { withGlobalContext } from '@util/global_context'
import styles from '@components/programmatic_blocks/brain_building_basics.module.scss'
import ImageAsset from '@components/image_asset'

const BrainBuildingBasic = ({ bbb }) => {
  const imageAsset = get(bbb, 'fields.cardImage')
  const header = get(bbb, 'fields.name')
  const body = get(bbb, 'fields.body')

  return (
    <div className={styles.brainBuildingBasic}>
      <div className={styles.brainBuildingBasic__image}>
        <ImageAsset asset={imageAsset} alt="" />
      </div>
      <div className={styles.brainBuildingBasic__text}>
        <div className={styles.brainBuildingBasic__header}>{header}</div>
        <div className={styles.brainBuildingBasic__body}>
          <Markdown>{body}</Markdown>
        </div>
      </div>
    </div>
  )
}

const BrainBuildingBasics = ({ fields, globalContext, locale }) => {
  const bbbs = globalContext.bbbs.map(bbb => {
    return <BrainBuildingBasic key={bbb.id} bbb={bbb} />
  })

  return (
    <div className="brainBuildingBasics">
      <CardFan>{bbbs}</CardFan>
    </div>
  )
}

export default withGlobalContext(BrainBuildingBasics)
